export default "__VITE_ASSET__CwZvTOF3__"